import {inject} from "react-ioc";
import {GAnalyticsService} from "app/modules/main/stores/GAnalyticsService";

export class AnalyticsService {
    @inject gAnalyticsService : GAnalyticsService;

    changeLocation = (path: string) => {
        this.gAnalyticsService.changeLocation(path);
    }

    login = () => {
        this.gAnalyticsService.login();
    }

    register = () => {
        this.gAnalyticsService.register();
    }

    forgotPassword = () => {
        this.gAnalyticsService.forgotPassword();
    }

    resetPasswordPassword = () => {
        this.gAnalyticsService.resetPasswordPassword();
    }

    marketingLink = (code) => {
        this.gAnalyticsService.marketingLink(code);
    }

    searchProperty = (city: string, state: string) => {
        this.gAnalyticsService.searchProperties(city, state);
    }

    lookAtProperty = (city: string, state: string, propertyId: number) => {
        this.gAnalyticsService.lookAtProperty(city, state, propertyId);
    }

    startBookingProperty = (propertyId: number) => {
        this.gAnalyticsService.startBookingProperty(propertyId);
    }

    paymentIntentBookingProperty = (id: number, reservationCode: string) => {
        this.gAnalyticsService.paymentIntentBookingProperty(id, reservationCode);
    }

    paymentMadeProperty = (id: number, reservationCode: string) => {
        this.gAnalyticsService.paymentMadeProperty(id, reservationCode);
    }
}
